// App.js (actualizado completo)
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import TrackingPage from './pages/TrackingPage';
import ServicioAlCliente from './pages/ServicioAlCliente';
// import Soporte from './pages/Soporte'; // Nueva importación
import ComingSoonPage from './pages/ComingSoonPage';
import LoginPage from './pages/LoginPage';
import TerminosDeServicio from './pages/TerminosDeServicio';
import PoliticaPrivacidad from './pages/PoliticaPrivacidad';
// import ProtectedRoute from './components/ProtectedRoute';
// import AuthRedirect from './components/AuthRedirect';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Ruta raíz con redirección inteligente */}
          <Route path="/" element={<TrackingPage />} />

          {/* Coming Soon - página pública */}
          <Route path="/coming-soon" element={<ComingSoonPage />} />

          {/* Login */}
          <Route path="/login" element={<LoginPage />} />

          {/* ✅ RUTA CON NÚMERO */}
          <Route path="/tracking/:trackingNumber" element={<TrackingPage />} />

          {/* ✅ RUTA SIN NÚMERO (búsqueda inicial) */}
          <Route path="/tracking" element={<TrackingPage />} />

          {/* ✅ RUTA DE SOPORTE TÉCNICO (acceso público) */}
          {/*
          <Route path="/soporte" element={<Soporte />} />
          */}

          {/* ✅ RUTA DE TÉRMINOS DE SERVICIO (acceso público) */}
          <Route
            path="/terminos-de-servicio"
            element={<TerminosDeServicio />}
          />

          {/* ✅ RUTA DE POLÍTICA DE PRIVACIDAD (acceso público) */}
          <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />

          <Route path="/servicio-al-cliente" element={<ServicioAlCliente />} />

          {/* Catch all - redirigir a la raíz */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
